/**
 * @graph-stack line-user-id-resolver
 * @graph-domain Infrastructure
 * @graph-business line-user-id-resolver フロントエンドのエントリーポイント。Faro 初期化後に React StrictMode + App を root にマウント
 * @graph-connects none
 */
// Faro初期化は他のimportより前に実行
import { initializeFaro } from '@cortex/faro';
initializeFaro({ appName: 'line-user-id-resolver' });

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';
import './i18n';

/** @graph-connects none */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
